import { render, staticRenderFns } from "./filterable-editor.vue?vue&type=template&id=5c0c4b3f&scoped=true&"
import script from "./filterable-editor.vue?vue&type=script&lang=js&"
export * from "./filterable-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c4b3f",
  null
  
)

export default component.exports